import { ReactNode } from 'react'

interface CardProps {
  title?: string
  value?: string | number
  icon?: string
  trend?: {
    value: number
    isUp: boolean
  }
  className?: string
  children?: ReactNode
  action?: ReactNode
  hover?: boolean
}

export default function Card({ 
  title, 
  value, 
  icon, 
  trend, 
  className = '', 
  children, 
  action,
  hover = true 
}: CardProps) {
  const hoverClasses = hover ? 'hover:shadow-lg transition-shadow duration-200' : ''
  
  // 如果有children，使用新的布局
  if (children) {
    return (
      <div className={`card-gradient rounded-xl p-6 shadow-soft border border-gray-100 ${hoverClasses} ${className}`}>
        {(title || action) && (
          <div className="flex items-center justify-between mb-4">
            {title && <h2 className="text-lg font-semibold text-gray-900">{title}</h2>}
            {action && <div className="animate-fade-in">{action}</div>}
          </div>
        )}
        <div>{children}</div>
      </div>
    )
  }

  // 原有的卡片布局
  return (
    <div className={`card-gradient rounded-xl p-6 shadow-soft border border-gray-100 ${hoverClasses} ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm text-gray-500 mb-1">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          {trend && (
            <p className={`text-sm mt-2 inline-flex items-center gap-1 font-medium ${
              trend.isUp ? 'text-green-600' : 'text-red-600'
            }`}>
              <span className="text-lg">{trend.isUp ? '↑' : '↓'}</span>
              {Math.abs(trend.value)}%
              <span className="text-gray-400 ml-1 font-normal">vs 上周</span>
            </p>
          )}
        </div>
        {icon && (
          <div className="text-4xl">
            {icon}
          </div>
        )}
      </div>
    </div>
  )
}
